module.exports = __webpack_public_path__ + "img/ids-sonangol.2edcad12.png";